module.exports = __webpack_public_path__ + "img/stacks.9d28c7db.svg";